import { render, staticRenderFns } from "./iconCloseCircle.vue?vue&type=template&id=35cf9299"
import script from "./iconCloseCircle.vue?vue&type=script&lang=js"
export * from "./iconCloseCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports